<template>
  <div class="form-course-item">
    <div class="form-item-title">{{ column.label }}:</div>
    <div>
      <van-checkbox-group v-model="value" @change="radioGroupChange">
        <van-checkbox shape="square" :name="item.value" v-for="(item, index) in dicData" :key="index">{{
          item.label
        }}</van-checkbox>
      </van-checkbox-group>
    </div>
  </div>
</template>

<script>
import {uuid} from '@/ultis'
export default {
  props: ['column'],
  data() {
    const preDeel = obj => {
      const newObj = obj.map(item => ({...item, value: uuid() + '_' + item.value}))
      return newObj
    }
    return {
      dicData: preDeel(this.column.dicData),
      value: []
    }
  },
  computed: {
    mapDicData() {
      const map = {}
      this.dicData.forEach(item => {
        map[item.value] = item
      })
      return map
    }
  },
  methods: {
    radioGroupChange(item) {
      const resultArr = item.map(item => this.mapDicData[item])
      const params1 = this.column.prop
      const params2 = '$' + this.column.prop
      const obj = {
        [params1]: resultArr.map(item => item.value.split('_')[1]),
        [params2]: resultArr.map(item => item.label).join('|')
      }
      this.$store.commit('setReport', obj)
    }
  }
}
</script>

<style>
.form-course-item .van-checkbox {
  margin-bottom: 10px;
}
</style>
